'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pubNubMessageKeyInvariant = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _PubNubMessageKey = require('../records/PubNubMessageKey');

var _PubNubMessageKey2 = _interopRequireDefault(_PubNubMessageKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pubNubMessageKeyInvariant = exports.pubNubMessageKeyInvariant = function pubNubMessageKeyInvariant(messageKey) {
  return (0, _invariant2.default)(messageKey instanceof _PubNubMessageKey2.default || typeof messageKey === 'string', 'Expected message to be a `PubNubMessageKey` not a `%s`', typeof messageKey === 'undefined' ? 'undefined' : _typeof(messageKey));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/invariants/pubNubMessageKeyInvariant.js
// module id = 230
// module chunks = 2 3